import store from "data/store";
import api from "services/api";

class TagsService {
  init = async () => {
    try {
      const { data } = await api.getTags();
      store.tags.set(data);
    } catch (error) {
      console.log("TagsService init", error);
    }
  };
}

export default new TagsService();
